import React, { useEffect } from "react";
import Swal from "sweetalert2";
import LogoPage from "../img/unauthorized.png";

const Unauthorized = () => {

    useEffect(() => {
        Swal.fire({
            title: "Permiso denegado",
            text: "Usted no cuenta con permisos para acceder a este módulo.",
            icon: "error",
            confirmButtonText: "Aceptar"
        });
    }, []);

    return (
        <div className="logoLandingPage-padre">
            <img
                className="logoLandingPage-hijo"
                alt="LogoPage"
                src={LogoPage}
            />
        </div>
    );
};

export default Unauthorized;